var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect } from "react";
import { Row, Col } from "../index";
import { getCssVarValue, isPropDefined } from "./Utils";
// fill div if only 1 widget
var getHalfScreenWidgetSize = function (componentsLength) {
    switch (componentsLength) {
        case 1:
            return 12;
        default:
            return 6;
    }
};
function Widgets(props) {
    var title = props.title, description = props.description, components = props.components;
    // change the background colour behind the widgets
    useEffect(function () {
        try {
            var backing = document.getElementById("tol-app-background");
            backing.style.backgroundColor = getCssVarValue("--bs-body-widget-bg");
        }
        catch (_a) {
            return;
        }
    }, []);
    // fill div if only 1 widget
    var halfSize = getHalfScreenWidgetSize(components.length);
    return (_jsxs(_Fragment, { children: [isPropDefined(title) || isPropDefined(description) ?
                _jsx(Row, __assign({ style: { marginLeft: 0, marginRight: 0, paddingLeft: 12, paddingRight: 12 } }, { children: _jsx(Col, __assign({ style: { paddingLeft: 0, paddingRight: 0 } }, { children: _jsxs("div", __assign({ className: "tol-widget" }, { children: [_jsx("h2", __assign({ className: "widget-title" }, { children: title })), _jsx("p", { children: description })] })) })) }))
                :
                    _jsx(_Fragment, {}), _jsx(Row, __assign({ style: { marginLeft: 0, marginRight: 0, paddingLeft: 12, paddingRight: 12 } }, { children: components.map(function (component, index) {
                    return (_jsx(Col, __assign({ lg: 12, xl: halfSize, style: { paddingLeft: 0, paddingRight: 0 } }, { children: _jsx("div", __assign({ className: "tol-widget" }, { children: component })) }), "tol-widget-".concat(index)));
                }) }))] }));
}
export default Widgets;
